import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import Fuse from "fuse.js";
import { blogPosts } from "../../data/blogData";

const BlogSection = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const postsPerPage = 3;

  // Fuse cho search
  const fuse = useMemo(() => {
    return new Fuse(blogPosts, {
      keys: ["title", "content.value"], // tìm trong title + đoạn content đầu
      threshold: 0.3,
    });
  }, []);

  // Nếu có query thì lấy kết quả search
  const searchResults = query.trim()
    ? fuse.search(query).map((r) => r.item)
    : [];

  // Pagination khi không search
  const totalPages = Math.ceil(blogPosts.length / postsPerPage);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogPosts.slice(indexOfFirstPost, indexOfLastPost);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // Lấy sidebar mặc định từ bài viết đầu tiên
  const sidebarCategories = blogPosts[0]?.sidebar?.categories || [];
  const recentPosts = blogPosts[0]?.sidebar?.recentPosts || [];
  const tags = blogPosts[0]?.sidebar?.tags || [];

  // Chọn data để render
  const displayPosts = query.trim() ? searchResults : currentPosts;

  return (
    <section className="news-section fix section-padding">
      <div className="container">
        <div className="news-list-wrapper">
          <div className="row g-4">
            {/* Danh sách blog chính */}
            <div className="col-lg-8">
              <div className="news-list-area">
                {displayPosts.length > 0 ? (
                  displayPosts.map((post) => (
                    <div
                      key={post.id}
                      className="news-list-items"
                    >
                      <div className="thumb">
                        <img
                          src={post.homeImg}
                          alt={post.title}
                        />
                      </div>
                      <div className="content">
                        <span>{post.date}</span>
                        <h3>
                          <Link to={`/bai-viet/${post.slug}`}>
                            {post.title}
                          </Link>
                        </h3>
                        <p>
                          {post.content && post.content.length > 0
                            ? post.content[0].value
                            : ""}
                        </p>
                        <div className="news-btn">
                          <Link
                            to={`/bai-viet/${post.slug}`}
                            className="link-btn"
                          >
                            Xem Chi Tiết
                          </Link>
                          <Link
                            to={`/bai-viet/${post.slug}`}
                            className="arrow-icon"
                          >
                            <img
                              src="/assets/img/icon/02.svg"
                              alt="icon"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-white">
                    Không tìm thấy bài viết nào.
                  </p>
                )}

                {/* Phân trang (chỉ hiển thị khi không search) */}
                {!query.trim() && (
                  <div className="page-nav-wrap pt-5 text-center">
                    <ul>
                      <li>
                        <button
                          className="page-numbers icon"
                          onClick={() => goToPage(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          <FaArrowLeft />
                        </button>
                      </li>
                      {Array.from({ length: totalPages }, (_, i) => (
                        <li key={i}>
                          <button
                            className={`page-numbers ${
                              currentPage === i + 1 ? "current" : ""
                            }`}
                            onClick={() => goToPage(i + 1)}
                          >
                            {i + 1 < 10 ? `0${i + 1}` : i + 1}
                          </button>
                        </li>
                      ))}
                      <li>
                        <button
                          className="page-numbers icon"
                          onClick={() => goToPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          <FaArrowRight />
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              <div className="main-sidebar">
                {/* Tìm kiếm */}
                <div className="single-sidebar-widget">
                  <div className="wid-title">
                    <h3>Tìm Kiếm</h3>
                  </div>
                  <div className="search-widget">
                    <form onSubmit={(e) => e.preventDefault()}>
                      <input
                        type="text"
                        placeholder="Nhập từ khóa tìm kiếm"
                        value={query}
                        onChange={(e) => {
                          setQuery(e.target.value);
                          setCurrentPage(1); // reset trang khi search
                        }}
                      />
                      <button type="submit">
                        <FiSearch />
                      </button>
                    </form>
                  </div>
                </div>

                {/* Danh mục */}
                <div className="single-sidebar-widget">
                  <div className="wid-title">
                    <h3>Top Danh Mục</h3>
                  </div>
                  <div className="news-widget-categories">
                    <ul>
                      {sidebarCategories.map((cat, i) => (
                        <li
                          key={i}
                          className={cat.active ? "active" : ""}
                        >
                          <Link to="#">{cat.name}</Link>{" "}
                          <span>({cat.count})</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Bài viết gần đây */}
                <div className="single-sidebar-widget">
                  <div className="wid-title">
                    <h3>Bài Viết Nổi Bật</h3>
                  </div>
                  <div className="recent-post-area">
                    {recentPosts.map((post, i) => (
                      <div
                        key={i}
                        className="recent-items"
                      >
                        <div className="recent-thumb">
                          <img
                            src={post.image}
                            alt={post.title}
                          />
                        </div>
                        <div className="recent-content">
                          <span>{post.date}</span>
                          <h6>
                            <Link to={`/bai-viet/${post.slug}`}>
                              {post.title}
                            </Link>
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Tags */}
                <div className="single-sidebar-widget">
                  <div className="wid-title">
                    <h3>Tags Phổ Biến</h3>
                  </div>
                  <div className="news-widget-categories">
                    <div className="tagcloud">
                      {tags.map((tag, i) => (
                        <Link
                          key={i}
                          to="#"
                        >
                          {tag}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Sidebar */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
